import format from '../../../../node_modules/date-fns/esm/format/index.js';

//
var script = {
  name: 'Date',
  props: ['node', 'updateAttrs', 'view'],
  computed: {
    timestamp() {
      return this.node && format(new Date(parseInt(this.node.attrs.timestamp, 10)), 'MMM d, y');
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/renderers/Date.vue_rollup-plugin-vue=script.js